var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Button,_vm._g(_vm._b({attrs:{"variant":"primary","size":"lg"},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(slotProps){return [_vm._t(name,null,null,slotProps || {})]}}})],null,true)},'Button',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }